export enum DayAvailabilityDataHooks {
  DayWithoutSlots = 'day-without-slots',
  DayWithoutSlotsSrOnly = 'day-without-slots-sr-only',
  DayWithSlotsSrOnly = 'day-with-slots-sr-only',
}
